import {
  FileContentType,
  FileType,
  IFileRefGetBaseName,
  IFileRefGetCleanPath,
  IFileReference,
  IFileRefIsLocal
} from '@summit/core';

import { EboObjectTO } from '../../base-classes/ebo-object-to';
import { Ask } from './ask';

export class AskFile extends EboObjectTO implements IFileReference {
  askId: string;
  ask: Ask;
  name: string;
  path: string;
  blobPath: string; // Required for dynamic file loading
  order: number;
  fileType: FileType;
  contentType: FileContentType;

  constructor(jsonData: Partial<AskFile>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.ask) this.ask = new Ask(jsonData.ask);
    }
    this.contentType ??= FileContentType.Attachment;
  }

  get baseName(): string {
    return IFileRefGetBaseName(this);
  }
  get cleanPath(): string {
    return IFileRefGetCleanPath(this);
  }
  get isLocal(): boolean {
    return IFileRefIsLocal(this);
  }
}
